class ReusableQuillEditorController {
  public ngModel: any; // Required: ng-model binding
  public readonly: boolean; // Optional: readonly binding
  public name: string; // Optional: name attribute
  public ariaLabel: string; // Optional: aria-label attribute
}

export const ReusableQuillEditorComponent = {
  template: require('./reusable-quill-editor.component.html'),
  controller: ReusableQuillEditorController,
  controllerAs: '$ctrl',
  bindings: {
    ngModel: '=', // Two-way binding for ng-model
    readonly: '<?', // Optional one-way binding for readonly
    name: '@?', // Optional string binding for name attribute
    ariaLabel: '@?' // Optional string binding for aria-label attribute
  }
};



// WEBPACK FOOTER //
// ./src/components/reusable-quill-editor/reusable-quill-editor.component.ts